
import link from '@/service/utils/links';
import * as localStorageKey from '@/service/const/localStorageKey';
import config from '@/service/config';
import { isZfbMiniProgram } from '@/service/ua';
// 渠道参数处理
const channelhanlder = function () {
  // 渠道参数缓存
  const blindMarketChannel = link.getUrlParamsByName('marketChannel');
  if (blindMarketChannel) {
    window.localStorage.setItem(
      localStorageKey.blindMarketChannel,
      blindMarketChannel,
    );
    try {
      if (/,/.test(blindMarketChannel) || blindMarketChannel.length > 20) {
        window.monitor && window.monitor.report({
          level: 'error',
          error: 'js',
          url: location.href,
          msg: `蜜柚集市投放渠道参数异常上报:${blindMarketChannel}`,
        });
      }
    } catch (e) {
      console.log('error', e);
    }
  }
  const channel = window.localStorage.getItem(localStorageKey.blindMarketChannel);
  // 修复渠道参数重复
  try {
    if (/,/.test(channel)) {
      const c = channel.split(',');
      if (c[0] === c[1]) {
        window.localStorage.setItem(
          localStorageKey.blindMarketChannel,
          c[0],
        );
      }
    }
  } catch (e) {
    console.log('error', e);
  }

  // 针对提审渠道参数 打上提审版本标识
  const isTaiShen = config.taiShenList.findIndex(item => channel === item) !== -1;
  if (isTaiShen && isZfbMiniProgram) {
    window.localStorage.setItem(localStorageKey.isTaiShen, 1);
  } else {
    window.localStorage.setItem(localStorageKey.isTaiShen, 0);
  }
};

export default channelhanlder;
